<template>
	<div data-tour-scope="setting-marketplace">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.marketplace') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni marketplace diventa una card, il form di configurazione resta dentro la card -->
								<tbody v-if="mobileCards" class="setmarket-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="s.logo" :alt="s.nome" /></v-avatar>
														{{ s.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="changeStatus(s.indice)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel
													v-if="checkpresenza(s.indice)"
													:servizio="s"
													:modello="modello(s)"
													:intestazione="false"
													:conferma="s.key !== 'ebay' || !!ebay.setting.authToken"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<template v-slot:dopo>
														<!-- Amazon: paesi e marketplace Renewed -->
														<template v-if="s.key === 'mws'">
															<div class="mk-section mt-4">Paesi</div>
															<div class="mk-paesi">
																<div v-for="paese in amazonPaesiCard" :key="paese.value" class="mk-paese">
																	<span class="d-inline-flex align-center">
																		<v-avatar size="18px" tile class="mr-2"><img :src="require(`@/assets/images/flag/${paese.flag}.svg`)" :alt="paese.flag" /></v-avatar>
																		{{ paese.nome }}
																	</span>
																	<v-switch v-model="mws.setting.country" :value="paese.value" color="primary" class="mt-0 pt-0" hide-details></v-switch>
																</div>
															</div>
															<v-select
																v-model="mws.setting.renewed.marketplaceIds"
																:items="amazonRenewedMarketplaceOptions"
																item-text="text"
																item-value="value"
																label="Marketplace approvati Amazon Renewed"
																hint="Seleziona solo i marketplace per cui l'account è già approvato Amazon Renewed"
																persistent-hint
																multiple
																small-chips
																dense
																outlined
																background-color="white"
																class="mt-4"
															/>
														</template>
														<!-- eBay: paesi e template, solo dopo l'autorizzazione -->
														<template v-if="s.key === 'ebay' && ebay.setting.authToken">
															<div class="mk-section mt-4">Paesi</div>
															<div class="mk-paesi">
																<div v-for="marketplace in ebayMarketplacesCard" :key="`ebay-${marketplace.marketplace}`" class="mk-paese">
																	<span class="d-inline-flex align-center">
																		<v-avatar size="18px" tile class="mr-2"><img :src="require(`@/assets/images/flag/${marketplace.flagCode}.svg`)" :alt="marketplace.flagCode" /></v-avatar>
																		{{ marketplace.marketplace }}
																	</span>
																	<v-switch v-model="ebay.setting.country" :value="marketplace.siteId" color="primary" class="mt-0 pt-0" hide-details></v-switch>
																</div>
															</div>
															<div class="mk-section mt-4">Template inserzioni</div>
															<div class="mk-template">
																<v-tabs v-model="ebayTemplateTab" height="38" background-color="transparent" class="mk-template-tabs">
																	<v-tab class="px-3">Header</v-tab>
																	<v-tab class="px-3">Footer</v-tab>
																</v-tabs>
																<div class="mk-template-body">
																	<div v-if="ebayTemplateTab === 0">
																		<div class="mk-hint">Non inserire gli asterischi (*).</div>
																		<ckeditor :editor="editor" v-model="ebay.setting.template.header" :config="editorConfig"></ckeditor>
																	</div>
																	<ckeditor v-else :editor="editor" v-model="ebay.setting.template.footer" :config="editorConfig"></ckeditor>
																</div>
															</div>
														</template>
													</template>
													<template v-slot:azioni>
														<v-btn v-if="s.key === 'ebay'" small outlined color="primary" @click="checkauthEbay(1)"><v-icon left small>mdi-shield-key-outline</v-icon>Autorizza app</v-btn>
														<v-btn v-if="s.key === 'ebay' && ebay.setting.authToken" small outlined color="primary" @click="getRateEbay(1)"><v-icon left small>mdi-cloud-sync-outline</v-icon>Sincronizza eBay</v-btn>
														<v-btn v-if="s.key === 'tiktokshop' && tiktokshop.active" small outlined color="primary" @click="checkauthTiktokShop()"><v-icon left small>mdi-shield-key-outline</v-icon>Autorizza app</v-btn>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
									<!-- marketplace senza configurazione: solo attivazione -->
									<tr v-for="m in marketplaceSempliciCard" :key="m.nome">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="m.logo" :alt="m.nome" /></v-avatar>
														{{ m.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-if="m.servizio" v-model="m.servizio.active" @change="changeStatus(m.indice)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" @change="changeStatus(s.indice)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel
													:servizio="s"
													:modello="modello(s)"
													:intestazione="true"
													:conferma="s.key !== 'ebay' || !!ebay.setting.authToken"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<template v-slot:dopo>
														<!-- Amazon: paesi e marketplace Renewed -->
														<template v-if="s.key === 'mws'">
															<div class="mk-section mt-4">Paesi</div>
															<div class="mk-paesi">
																<div v-for="paese in amazonPaesiCard" :key="paese.value" class="mk-paese">
																	<span class="d-inline-flex align-center">
																		<v-avatar size="18px" tile class="mr-2"><img :src="require(`@/assets/images/flag/${paese.flag}.svg`)" :alt="paese.flag" /></v-avatar>
																		{{ paese.nome }}
																	</span>
																	<v-switch v-model="mws.setting.country" :value="paese.value" color="primary" class="mt-0 pt-0" hide-details></v-switch>
																</div>
															</div>
															<v-select
																v-model="mws.setting.renewed.marketplaceIds"
																:items="amazonRenewedMarketplaceOptions"
																item-text="text"
																item-value="value"
																label="Marketplace approvati Amazon Renewed"
																hint="Seleziona solo i marketplace per cui l'account è già approvato Amazon Renewed"
																persistent-hint
																multiple
																small-chips
																dense
																outlined
																background-color="white"
																class="mt-4"
															/>
														</template>
														<!-- eBay: paesi e template, solo dopo l'autorizzazione -->
														<template v-if="s.key === 'ebay' && ebay.setting.authToken">
															<div class="mk-section mt-4">Paesi</div>
															<div class="mk-paesi">
																<div v-for="marketplace in ebayMarketplacesCard" :key="`ebay-${marketplace.marketplace}`" class="mk-paese">
																	<span class="d-inline-flex align-center">
																		<v-avatar size="18px" tile class="mr-2"><img :src="require(`@/assets/images/flag/${marketplace.flagCode}.svg`)" :alt="marketplace.flagCode" /></v-avatar>
																		{{ marketplace.marketplace }}
																	</span>
																	<v-switch v-model="ebay.setting.country" :value="marketplace.siteId" color="primary" class="mt-0 pt-0" hide-details></v-switch>
																</div>
															</div>
															<div class="mk-section mt-4">Template inserzioni</div>
															<div class="mk-template">
																<v-tabs v-model="ebayTemplateTab" height="38" background-color="transparent" class="mk-template-tabs">
																	<v-tab class="px-3">Header</v-tab>
																	<v-tab class="px-3">Footer</v-tab>
																</v-tabs>
																<div class="mk-template-body">
																	<div v-if="ebayTemplateTab === 0">
																		<div class="mk-hint">Non inserire gli asterischi (*).</div>
																		<ckeditor :editor="editor" v-model="ebay.setting.template.header" :config="editorConfig"></ckeditor>
																	</div>
																	<ckeditor v-else :editor="editor" v-model="ebay.setting.template.footer" :config="editorConfig"></ckeditor>
																</div>
															</div>
														</template>
													</template>
													<template v-slot:azioni>
														<v-btn v-if="s.key === 'ebay'" small outlined color="primary" @click="checkauthEbay(1)"><v-icon left small>mdi-shield-key-outline</v-icon>Autorizza app</v-btn>
														<v-btn v-if="s.key === 'ebay' && ebay.setting.authToken" small outlined color="primary" @click="getRateEbay(1)"><v-icon left small>mdi-cloud-sync-outline</v-icon>Sincronizza eBay</v-btn>
														<v-btn v-if="s.key === 'tiktokshop' && tiktokshop.active" small outlined color="primary" @click="checkauthTiktokShop()"><v-icon left small>mdi-shield-key-outline</v-icon>Autorizza app</v-btn>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
									<!-- marketplace senza configurazione: solo attivazione -->
									<tr v-for="m in marketplaceSempliciCard" :key="m.nome">
										<td></td>
										<td>
											<v-avatar size="32px" tile>
												<img :src="m.logo" :alt="m.nome" />
											</v-avatar>
											{{ m.nome }}
										</td>
										<td>
											<v-switch v-if="m.servizio" v-model="m.servizio.active" @change="changeStatus(m.indice)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createMarketplaceTourSteps, stopMarketplaceTour } from './marketplace-tour';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import { regions } from '../../utils/amazonPartner';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import ServicePanel from './components/ServicePanel.vue';

const ebayMarketplaces = [
	{ marketplace: 'Austria', siteId: '16', flagCode: 'AT' },
	{ marketplace: 'Australia', siteId: '15', flagCode: 'AU' },
	{ marketplace: 'Belgium', siteId: '23', flagCode: 'BE' },
	{ marketplace: 'Canada', siteId: '2', flagCode: 'CA' },
	{ marketplace: 'Switzerland', siteId: '193', flagCode: 'CH' },
	{ marketplace: 'Germany', siteId: '77', flagCode: 'DE' },
	{ marketplace: 'Spain', siteId: '186', flagCode: 'ES' },
	{ marketplace: 'France', siteId: '71', flagCode: 'FR' },
	{ marketplace: 'Great Britain', siteId: '3', flagCode: 'GB' },
	{ marketplace: 'Hong Kong', siteId: '201', flagCode: 'HK' },
	{ marketplace: 'Ireland', siteId: '205', flagCode: 'IE' },
	{ marketplace: 'India', siteId: '203', flagCode: 'IN' },
	{ marketplace: 'Italy', siteId: '101', flagCode: 'IT' },
	{ marketplace: 'eBay Motors US', siteId: '100', flagCode: 'US' },
	{ marketplace: 'Malaysia', siteId: '207', flagCode: 'MY' },
	{ marketplace: 'Netherlands', siteId: '146', flagCode: 'NL' },
	{ marketplace: 'Philippines', siteId: '211', flagCode: 'PH' },
	{ marketplace: 'Poland', siteId: '212', flagCode: 'PL' },
	{ marketplace: 'Russia', siteId: '215', flagCode: 'RU' },
	{ marketplace: 'Singapore', siteId: '216', flagCode: 'SG' },
	{ marketplace: 'United States', siteId: '0', flagCode: 'US' },
];

// paesi Amazon mostrati nella vista card (stessi valori/bandiere della tabella desktop)
const amazonPaesiCard = [
	{ value: 'ES', flag: 'ES', nome: 'Spain' },
	{ value: 'FR', flag: 'FR', nome: 'France' },
	{ value: 'GB', flag: 'UK', nome: 'United Kingdom' },
	{ value: 'NL', flag: 'NL', nome: 'Netherlands' },
	{ value: 'DE', flag: 'DE', nome: 'Germany' },
	{ value: 'IT', flag: 'IT', nome: 'Italy' },
	{ value: 'SE', flag: 'SE', nome: 'Sweden' },
	{ value: 'PL', flag: 'PL', nome: 'Poland' },
	{ value: 'BE', flag: 'BE', nome: 'Belgium' },
	{ value: 'IE', flag: 'IE', nome: 'Ireland' },
];

Vue.use(CKEditor);
export default {
	name: 'Marketplace',
	setup() {
		return { tour: useTour(createMarketplaceTourSteps(), { onStop: stopMarketplaceTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			editor: ClassicEditor,
			//editor: InlineEditor,
			editorConfig: {
				ckfinder: {
					uploadUrl: '',
				},
			},
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			headers: [{ text: '', sortable: false }, { text: 'Marketplace', sortable: false }, { text: 'Status', sortable: false }],
			messages: {
				email: [],
				name: [],
				password: [],
			},
			regionOptions: [
				{ text: 'Europa (eu)', value: 'eu' },
				{ text: 'Nord America (na)', value: 'na' },
				{ text: 'Estremo Oriente (fe)', value: 'fe' },
			],
			isMobile: false,
			connectionCheck: { open: false, service: 'amazon' },
			// tab Header/Footer dei template eBay
			ebayTemplateTab: 0,
			mws: {
				active: '',
				setting: {
					AWSAccessKeyId: '',
					SecretKey: '',
					CLIENT_IDENTIFIER: '',
					AMAZON_REFRESH_TOKEN: '',
					CLIENT_SECRET: '',
					IAM_ARN: '',
					ID_APP: '',
					region: '',
					items: '',
					quantity: '',
					category: '',
					order: '',
					prime: '',
					selling_partner_id: '',
					active: '',
					state: '',
					country: [],
					renewed: { marketplaceIds: [] },
				},

				type: 'marketplace',
				service: 'mws',
			},
			ebay: {
				active: '',
				setting: {
					authToken: '',
					template: {
						header: '',
						footer: '',
						body: '1',
					},
					country: [],
				},

				service: 'ebay',
				type: 'marketplace',
			},
			tiktokshop: {
				active: '',
				setting: {
					clientKey: '',
					clientSecret: '',
				},

				service: 'tiktokshop',
				type: 'marketplace',
			},
			prestashop: {
				active: '',
			},
			shopify: {
				active: '',
			},
			woocommerce: {
				active: '',
			},
			website: {
				active: '',
				webhook: '',
			},
		};
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	async created() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(['mws', 'ebay', 'tiktokshop']));
		await Promise.all(promises);

		//await this.fetchSettings();
		this.editorConfig.ckfinder.uploadUrl = `${this.getUrl}multimedias/ckeditor?token=${this.getToken}`;
		//this.items = result.data.data

		this.setPreload(false);

		let mws = _.find(this.getServices, set => {
			return set.service === 'mws';
		});

		/*console.log('MWS', mws);
		return;*/
		if (mws) {
			this.mws = mws;
			if (!this.mws.setting.renewed) this.$set(this.mws.setting, 'renewed', { marketplaceIds: [] });
			if (!Array.isArray(this.mws.setting.renewed.marketplaceIds)) this.$set(this.mws.setting.renewed, 'marketplaceIds', []);
		}
		let ebay = _.find(this.getServices, set => {
			return set.service === 'ebay';
		});
		if (ebay) {
			this.ebay.active = ebay.active;
			this.ebay.setting = ebay.setting;

			/*if (_.isArray(ebay.setting.country) && _.size(ebay.setting.country) > 0) {
				_.forEach(ebay.setting.country, country => {
					this.ebay.setting.country.push(country);
				});
			}*/

			if (!this.ebay?.setting?.template) {
				Object.assign(this.ebay.setting, { template: { header: '', footer: '', body: '1' } });
			} else {
				this.ebay.setting.template.header = _.unescape(this.ebay.setting.template.header);
				this.ebay.setting.template.footer = _.unescape(this.ebay.setting.template.footer);
			}
		}
		let tiktokshop = _.find(this.getServices, set => {
			return set.service === 'tiktokshop';
		});
		if (tiktokshop) {
			this.tiktokshop = tiktokshop;
		}
	},

	components: {
		TourOverlay,
		KeyValueCard,
		MarketplaceConnectionCheck,
		ServicePanel,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		amazonPaesiCard() {
			return amazonPaesiCard;
		},
		amazonRenewedMarketplaceOptions() {
			return regions
				.filter(region => this.mws?.setting?.country?.includes(region.country_code))
				.map(region => ({ text: `${region.marketplace} (${region.country_code})`, value: region.MarketplaceId }));
		},
		ebayMarketplacesCard() {
			return ebayMarketplaces;
		},
		// marketplace senza form per la vista card: stessi indici di changeStatus/extension della tabella desktop
		// marketplace configurabili: indice = argomento di saveSetting/changeStatus/extension, key = oggetto in data
		servizi() {
			return [
				{
					indice: 0,
					key: 'mws',
					nome: 'Amazon eu-west-1',
					logo: require('@/assets/images/marketplace/Amazon.svg'),
					connessione: 'amazon',
					campi: [
						{ key: 'ID_APP', label: 'ID app' },
						{ key: 'region', label: 'Region', tipo: 'select', items: this.regionOptions },
						{ key: 'CLIENT_IDENTIFIER', label: 'Client Identifier' },
						{ key: 'CLIENT_SECRET', label: 'Client Secret', tipo: 'password' },
						{ key: 'selling_partner_id', label: 'Selling Partner ID', pieno: true },
						{ key: 'AMAZON_REFRESH_TOKEN', label: 'Refresh Token', tipo: 'textarea', pieno: true },
						{ key: 'items', label: 'Anagrafica prodotti', tipo: 'switch' },
						{ key: 'quantity', label: 'Giacenze prodotti', tipo: 'switch' },
						{ key: 'prime', label: 'Importa ordini Prime', tipo: 'switch' },
						{ key: 'order', label: 'Ordini', tipo: 'switch' },
					],
				},
				{
					indice: 1,
					key: 'ebay',
					nome: 'Ebay',
					logo: require('@/assets/images/marketplace/Ebay.svg'),
					connessione: 'ebay',
					campi: [
						...(this.ebay.setting.authToken ? [{ key: 'authToken', label: 'Auth Token', tipo: 'textarea', readonly: true, pieno: true }] : []),
						{ key: 'items', label: 'Anagrafica prodotti', tipo: 'switch' },
						{ key: 'quantity', label: 'Giacenze prodotti', tipo: 'switch' },
						{ key: 'order', label: 'Ordini', tipo: 'switch' },
					],
				},
				{
					indice: 2,
					key: 'tiktokshop',
					nome: 'TikTok Shop',
					logo: require('@/assets/images/marketplace/tiktok.svg'),
					campi: [
						{ key: 'clientKey', label: 'Client Key' },
						{ key: 'clientSecret', label: 'Client Secret', tipo: 'password' },
					],
				},
			];
		},
		marketplaceSempliciCard() {
			return [
				{ indice: 3, nome: 'Manomano', logo: require('@/assets/images/marketplace/manomano_icon.svg'), servizio: this.manomano },
				{ indice: 4, nome: 'Aliexpress', logo: require('@/assets/images/marketplace/aliexpress.svg'), servizio: this.aliexpress },
				{ indice: 5, nome: 'Bricobravo', logo: require('@/assets/images/marketplace/bricobravo_icon.svg'), servizio: this.bricobravo },
				{ indice: 6, nome: 'Eprice', logo: require('@/assets/images/marketplace/eprice.svg'), servizio: this.eprice },
				{ indice: 7, nome: 'Etsy', logo: require('@/assets/images/marketplace/etsy.svg'), servizio: this.etsy },
				{ indice: 8, nome: 'Leroy Merlin', logo: require('@/assets/images/marketplace/LeroyMerlin.svg'), servizio: this.leroymerlin },
				{ indice: 9, nome: 'Temu', logo: require('@/assets/images/marketplace/temu.svg'), servizio: this.temu },
				{ indice: 10, nome: 'Zalando', logo: require('@/assets/images/marketplace/Zalando_Brandmark_Orange.svg'), servizio: this.zalando },
				{ indice: 11, nome: 'About You', logo: require('@/assets/images/marketplace/aboutyou.png'), servizio: this.aboutyou },
				{ indice: 12, nome: 'Farfetch', logo: require('@/assets/images/marketplace/farfetch.png'), servizio: this.farfetch },
				{ indice: 13, nome: 'Vestiaire Collective', logo: require('@/assets/images/marketplace/vestiaire.png'), servizio: this.vestiaire },
				{ indice: 14, nome: 'Spartoo', logo: require('@/assets/images/marketplace/spartoo.png'), servizio: this.spartoo },
				{ indice: 15, nome: 'Modivo', logo: require('@/assets/images/marketplace/modivo.png'), servizio: this.modivo },
				{ indice: 16, nome: 'Veepee', logo: require('@/assets/images/marketplace/veepee.png'), servizio: this.veepee },
				{ indice: 17, nome: 'Decathlon', logo: require('@/assets/images/marketplace/decathlon.png'), servizio: this.decathlon },
				{ indice: 18, nome: 'MediaWorld', logo: require('@/assets/images/marketplace/mediaworld.png'), servizio: this.mediaworld },
				{ indice: 19, nome: 'idealo', logo: require('@/assets/images/marketplace/idealo.png'), servizio: this.idealo },
			];
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',
			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',
			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
			//'resetMessages' : 'settings/resetMessages'
		}),
		changeStatus(item) {
			let payload;
			switch (item) {
				case 0:
					payload = this.mws;
					this.setPreload(true);

					break;
				case 1:
					payload = this.ebay;
					this.setPreload(true);

					break;
				case 2:
					payload = this.tiktokshop;
					this.setPreload(true);

					break;
			}
			//let url = 'profile/update/active';
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;

					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(item)
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		activeApp() {
			/// console.log(this.getSettings)

			let mws = _.find(this.getServices, set => {
				return set.service === 'mws';
			});

			if (mws) {
				this.mws.active = mws.active;
				this.mws.setting = mws.setting;
				//console.log(`https://sellercentral-europe.amazon.com/apps/authorize/consent?application_id=${this.mws.setting.ID_APP}&version=beta`);
				window.location.href = `https://sellercentral-europe.amazon.com/apps/authorize/consent?application_id=${this.mws.setting.ID_APP}&version=beta`;
			}
		},
		activeAppStep2() {
			let mws = _.find(this.getServices, set => {
				return set.service === 'mws';
			});

			if (mws) {
				this.mws.active = mws.active;
				this.mws.setting = mws.setting;
				window.location.href = `${this.mws.setting.activeurl}`;
			}
		},
		resetauth(item) {
			let payload;
			let url;
			switch (item) {
				case 0:
					payload = {};
					url = 'amazoneuwest1/auth/reset';
					this.preload = true;

					break;
				case 1:
					payload = {};
					this.preload = true;

					break;
			}

			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;

					this.setService(data.data);
					let mws = _.find(data.data.settings, set => {
						return set.service === 'mws';
					});
					if (mws) {
						this.mws.setting = mws.setting;
					}
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		getRateEbay() {
			this.setPreload(true);
			let url = 'ebay/updateSetting';
			axios
				.get(`${this.getUrl}${url}`, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setSettings(data.data);
					this.setPreload(false);
					//this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		checkauthEbay() {
			this.setPreload(true);
			let url = 'ebay/oauth';
			axios
				.get(`${this.getUrl}${url}`, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					console.log(data);
					this.setPreload(false);
					window.location.href = data.redirect;
					/*this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;*/
				})
				.catch(err => {
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		checkauthTiktokShop() {
			this.setPreload(true);
			let url = 'tiktokshop/auth/url';
			axios
				.get(`${this.getUrl}${url}`, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					window.location.href = data.redirect;
				})
				.catch(err => {
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		checkauth(item) {
			let payload;
			let url;
			switch (item) {
				case 0:
					payload = {};
					url = 'amazoneuwest1/auth';
					this.preload = true;

					break;
				case 1:
					payload = {};
					this.preload = true;

					break;
			}

			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setService(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		lwarefreshtoken(item) {
			let payload;
			let url;
			switch (item) {
				case 0:
					payload = {};
					url = 'amazoneuwest1/refreshtoken';
					this.preload = true;

					break;
				case 1:
					payload = {};
					this.preload = true;

					break;
			}

			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setService(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					console.log(err.response.data.message);
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		saveSetting(item) {
			let payload;
			this.setPreload(true);
			switch (item) {
				case 0:
					if (typeof this.mws.setting.selling_partner_id === 'string') {
						this.mws.setting.selling_partner_id = this.mws.setting.selling_partner_id.trim();
					}
					payload = this.mws;

					break;
				case 1:
					payload = _.cloneDeep(this.ebay);
					delete payload.setting.rateTables;
					delete payload.setting.FulfillmentPolicies;
					delete payload.setting.PaymentPolicies;
					delete payload.setting.returnPolicies;
					delete payload.setting.customPolicies;

					break;
				case 2:
					payload = this.tiktokshop;

					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(`${this.getUrl}${url}`);
		},
		extension(item) {
			let prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				let indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del marketplace (mws, ebay, tiktokshop): created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},

	},
};
</script>

<style></style>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* contenuti dei riquadri Amazon/eBay (slot di ServicePanel, compilati qui) */
.mk-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.mk-paesi {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
	gap: 8px;
}
.mk-paese {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	padding: 6px 10px;
	font-size: 14px;
}
.mk-template {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.mk-template-tabs {
	border-bottom: 1px solid #eef2f7;
}
.mk-template-tabs ::v-deep .v-tab {
	min-width: 0;
	font-size: 12px;
}
.mk-template-body {
	padding: 10px;
}
.mk-hint {
	font-size: 12px;
	color: #5f6b7a;
	margin-bottom: 6px;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.setmarket-cards,
.setmarket-cards tr {
	display: block;
	width: 100%;
}
.setmarket-cards tr,
.setmarket-cards tr:hover {
	background: transparent !important;
}
.setmarket-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.setmarket-cards tr:first-child td {
	padding-top: 12px !important;
}
.setmarket-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.setmarket-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
